import React from 'react'
import styled from '@emotion/styled'

import SearchBar from '../../SearchBar'
import { ButtonTransparent } from '../../common/Button'
import { MEDIA_WIDTHS } from '../../../constants'
import { TeamRoleSelector } from './TeamRoleSelector'

interface Props {
  setFilters: any
  filters: Record<string, any>
}

export const Filters = ({ filters, setFilters }: Props) => {
  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const search = event.currentTarget.value

    setFilters((state: any) => ({ ...state, search }))
  }

  const handleChangeRole = (event: any) => {
    const selectedValue: any = event.target.value
    setFilters((state: any) => ({ ...state, role: selectedValue }))
  }

  const onClearFiters = () => {
    setFilters({
      search: '',
      role: []
    })
  }

  return (
    <Container>
      <SearchBar
        name="search"
        value={filters.search}
        onChange={handleSearchChange}
        placeholder="Search by Wallet or Name"
      />
      <TeamRoleSelector value={filters.role} onChange={handleChangeRole} />
      <ClearFiltersButton onClick={onClearFiters}>Clear</ClearFiltersButton>
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  gap: 20px;
  > * {
    flex: 1;
  }

  @media (max-width: ${MEDIA_WIDTHS.upToSmall}px) {
    flex-direction: column;
  }
`

const ClearFiltersButton = styled(ButtonTransparent)`
  background-color: #1e2223 !important;
  color: white;
  text-transform: none;
  white-space: nowrap;
  padding: 15px 22px !important;
  max-width: 136px;
  @media (max-width: ${MEDIA_WIDTHS.upToSmall}px) {
    max-width: 100%;
  }
`
